import React from "react";
import styles from "./OwnerTab.module.css";
// import profilePic from "../../assets/images/img.jpg";

const OwnerTab = ({ data }) => {
  if (!data || !data.summary) return null;

  const summary = data.summary || {};
  const standardOwnerName =
    summary.standardOwnerName ||
    summary.standardOwner ||
    summary.StandardOwner ||
    summary.standardOwnerLabel ||
    "";
  const standardOwnerEmail =
    summary.standardOwnerEmail ||
    summary.standardOwnerMail ||
    summary.standardOwnerUserPrincipalName ||
    "";
  const functionalOwner =
    summary.functionalOwner || summary.FunctionalOwner || "N/A";
  const responsibleTeam =
    summary.responsibleTeam || summary.ResponsibleTeam || "";
  const regionOwner = summary.regionOwner || summary.RegionOwner || "";

  const ownerMeta = [
    responsibleTeam ? `Responsible Team: ${responsibleTeam}` : "",
    regionOwner ? `Region Owner: ${regionOwner}` : "",
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <section className={styles.standardOwner}>
      <div className={styles.section}>
        <span className={styles.widgetTitle}>
          <h5>Standard Owner</h5>
        </span>
        <div className={styles.ownerCard}>
          {/*
          <img
            src={profilePic}
            alt="Standard owner profile"
            className={styles.ownerAvatar}
          />
          */}
          <div className={styles.ownerInfo}>
            <p className={styles.ownerName}>{standardOwnerName || functionalOwner}</p>
            {standardOwnerEmail ? (
              <p className={styles.ownerEmail}>{standardOwnerEmail}</p>
            ) : null}
            <p className={styles.ownerRole}>{ownerMeta || "N/A"}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OwnerTab;
